import http from './http';
import serviceHelper from './serviceHelper';

export const uploadBulkImages = async (formData: FormData) => {
  return serviceHelper(
    http.post('/upload/user/image/bulk', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
    false,
    true
  );
};

export const submitSchoolReport = async (data: {
  issue: string;
  description: string;
  asset_ids: string[];
}) => {
  return serviceHelper(http.post('/school/report', data), false, true);
};
